import { BRAND_GLOBAL_VARIABLE } from '../constants/brand-global'
import { BrandSettingsInterface } from '../types/brand-settings'

type BrandGlobalScope = Record<string, unknown>

const getBrandScope = (): BrandGlobalScope | null =>
  typeof window !== 'undefined' ? (window as unknown as BrandGlobalScope) : null

export const setGlobalBrand = (brand: BrandSettingsInterface) => {
  const scope = getBrandScope()

  if (!scope) {
    return
  }

  scope[BRAND_GLOBAL_VARIABLE] = brand
}

export const getGlobalBrand = (): BrandSettingsInterface | null => {
  const scope = getBrandScope()

  if (!scope) {
    return null
  }

  const brand = scope[BRAND_GLOBAL_VARIABLE] as BrandSettingsInterface | undefined | null

  return brand ?? null
}
